'use client';

import type { ListHomeNoticePrizeDto } from '__generated__/api/unauth';
import { Button, Modal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

interface CheckWinnerButtonProps {
  winnerList: ListHomeNoticePrizeDto[];
}

export const CheckWinnerButton = ({ winnerList }: CheckWinnerButtonProps) => {
  const memberCode = useAuthStore((state) => state.myInfo?.memberCode);
  const pathname = usePathname();
  const [isWinnerModalOpen, setIsWinnerModalOpen] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const router = useCustomRouter();

  const matched =
    memberCode && winnerList.length > 0
      ? winnerList.find(({ noticePrizeWinnerList: notice_prize_winner_list }) =>
          notice_prize_winner_list?.some(
            ({ memberCode: listMemberCode }) => listMemberCode === memberCode,
          ),
        )
      : undefined;
  const isWinner = Boolean(matched);
  const winnerPrizeName = matched?.prizeName ?? '';

  const handleCheckClick = () => {
    if (!memberCode) {
      router.push(
        ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: pathname ?? window.location.pathname,
          },
        }),
      );

      return;
    }

    if (isWinner) {
      setIsWinnerModalOpen(true);
    } else {
      setIsFailedModalOpen(true);
    }
  };

  return (
    <>
      <Button className="w-full" onClick={handleCheckClick}>
        당첨 확인하기
      </Button>

      <WinnerModal
        open={isWinnerModalOpen}
        onClose={() => setIsWinnerModalOpen(false)}
        eventName={winnerPrizeName}
      />
      <FailedModal
        open={isFailedModalOpen}
        onClose={() => setIsFailedModalOpen(false)}
      />
    </>
  );
};

interface WinnerModalProps {
  open: boolean;
  onClose: () => void;
  eventName: string;
}

const WinnerModal = ({ open, onClose, eventName }: WinnerModalProps) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      header={
        <span className="w-full text-center">
          이벤트 당첨을
          <br />
          축하드려요!
        </span>
      }
      description={
        <span className="block text-center">
          [경품]
          <br />
          {eventName}
        </span>
      }
      buttonFooter={
        <Button dimensions="H48" onClick={onClose}>
          확인
        </Button>
      }
    />
  );
};

interface FailedModalProps {
  open: boolean;
  onClose: () => void;
}

const FailedModal = ({ open, onClose }: FailedModalProps) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      header={<span className="w-full text-center">다음 기회를..</span>}
      description={
        <span className="block text-center">
          안타깝게도 당첨이 안 되었어요.
          <br />
          다음 이벤트를 기대해 주세요!
        </span>
      }
      buttonFooter={
        <Button dimensions="H48" onClick={onClose}>
          확인
        </Button>
      }
    />
  );
};
